import { call, put, takeLatest } from 'redux-saga/effects';

import { getFileCategoriesList } from '../../services/API';
import { actionTypes, requestFailure, requestSuccess } from './actions';

function* getData() {
  const response = yield call(getFileCategoriesList);
  if (response.isOk) {
    return put(requestSuccess(response.data));
  }
  return put(requestFailure(response.error));
}

export default function* getFileCategoriesListSaga() {
  yield takeLatest(actionTypes.REQUEST_START, getData);
}
